import * as React from "react";
import { Progress as ProgressPrimitive } from "radix-ui";

import { cn } from "../lib/utils";

/**
 * shadcn `progress` primitive (new-york), adapted to the unified `radix-ui`
 * import convention. Atlas-styled: `bg-muted` track, accent (`bg-primary`)
 * indicator — a sanctioned accent use. Radix supplies the progressbar ARIA
 * contract (role + aria-valuenow); the indicator width tracks the value by
 * translating the full-width bar left by (100 - value)%.
 */
function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "bg-muted relative h-2 w-full overflow-hidden rounded-field",
        className,
      )}
      value={value}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary h-full w-full flex-1 transition-transform duration-150 motion-reduce:transition-none"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
